"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTvCodeWithServer = exports.validateTvCode = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var validateTvCode = exports.validateTvCode = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(tvCode) {
    var response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _axios2.default)({
              method: "POST",
              url: "/code/validateCode",
              headers: { "content-type": "application/json" },
              data: {
                tvCode: tvCode
              }
            });

          case 2:
            response = _context.sent;

            if (!response.data) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", response.data);

          case 7:
            throw new Error("Could not validate " + _Cookie.tvCodeSessionStorageName);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function validateTvCode(_x) {
    return _ref.apply(this, arguments);
  };
}();

var validateTvCodeWithServer = exports.validateTvCodeWithServer = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(req, res) {
    var tvCode, response, validatedData, validatedTvCode, validatedTvData, error, errorResponse;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            tvCode = req.body.tvCode;
            _context2.prev = 1;
            _context2.next = 4;
            return (0, _axios2.default)({
              method: "POST",
              url: _config2.default.tvToWebUrl + "/tv/validateTvCode",
              headers: { "content-type": "application/json" },
              data: {
                tvCode: tvCode
              }
            });

          case 4:
            response = _context2.sent;
            validatedData = response.data;
            validatedTvCode = validatedData.tvCode, validatedTvData = validatedData.tvData, error = validatedData.error;

            if (error) {
              _context2.next = 11;
              break;
            }

            res.json({ tvCode: validatedTvCode, tvData: validatedTvData });
            _context2.next = 12;
            break;

          case 11:
            throw new Error(error);

          case 12:
            _context2.next = 19;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            errorResponse = _context2.t0.response.data.error;

            console.error("Error validating code:", errorResponse);
            res.status(400).json({ error: errorResponse });

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[1, 14]]);
  }));

  return function validateTvCodeWithServer(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

var _Cookie = require("./Cookie");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ValidateTvCode.js
// module id = 278
// module chunks = 0